var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChartSteps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0C0.776142 0 1 0.223858 1 0.5V15.5C1 15.7761 0.776142 16 0.5 16C0.223858 16 0 15.7761 0 15.5V0.5C0 0.223858 0.223858 0 0.5 0Z",
    fill: "#5F6877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5C2 1.22386 2.22386 1 2.5 1H6.5C6.77614 1 7 1.22386 7 1.5V2.5C7 2.77614 6.77614 3 6.5 3H2.5C2.22386 3 2 2.77614 2 2.5V1.5Z",
    fill: "#5F6877"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5C4 5.22386 4.22386 5 4.5 5H11.5C11.7761 5 12 5.22386 12 5.5V6.5C12 6.77614 11.7761 7 11.5 7H4.5C4.22386 7 4 6.77614 4 6.5V5.5Z",
    fill: "#5F6877"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5C6 9.22386 6.22386 9 6.5 9H12.5C12.7761 9 13 9.22386 13 9.5V10.5C13 10.7761 12.7761 11 12.5 11H6.5C6.22386 11 6 10.7761 6 10.5V9.5Z",
    fill: "#5F6877"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5C8 13.2239 8.22386 13 8.5 13H15.5C15.7761 13 16 13.2239 16 13.5V14.5C16 14.7761 15.7761 15 15.5 15H8.5C8.22386 15 8 14.7761 8 14.5V13.5Z",
    fill: "#5F6877"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartSteps);
export default __webpack_public_path__ + "static/media/bar-chart-steps.4ea18dbfee857d17de05f60e2b925835.svg";
export { ForwardRef as ReactComponent };